import { getData } from '../utils/ajax-utils';

export function initPvid(): void {
    document.querySelectorAll<HTMLElement>('.js-pvid-tunnel').forEach($container => {
        new PvidTunnel($container);
    });
}

class PvidTunnel {
    $container: HTMLElement;
    $steps: HTMLElement[];
    orderRefExt: string;
    interval: ReturnType<typeof setInterval>;
    abortController: AbortController|null = null;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$steps = Array.from(this.$container.querySelectorAll<HTMLElement>('[data-step]'));
        this.orderRefExt = this.$container.dataset.orderRefExt as string;

        this.showStep(1);

        // Récupère l'étape à afficher toutes les 2 secondes
        this.interval = setInterval(() => {
            if (this.abortController) {
                // Si une requête est déjà en cours, on attend la fin de celle-ci histoire de pas l'annuler
                return;
            }

            this.abortController = new AbortController();

            getData(scriptVar.ajaxUrl, {
                action: 'get_pvid_tunnel_step',
                order_ref_ext: this.orderRefExt,
            }, this.abortController.signal).then(response => {
                this.abortController = null;

                if (!response.success) {
                    return;
                }

                if (2 === response.data) {
                    this.showStep(2);
                } else if (3 === response.data) {
                    clearInterval(this.interval);
                    this.redirectToOrder();
                }
            }).catch(() => {
                this.redirectToOrder();
            });
        }, 2000);
    }

    /**
     * Affiche une étape et masque les autres
     * 
     * @param {number} number
     * 
     * @return {void}
     */
    showStep(number: number): void {
        this.$steps.forEach($step => {
            $step.classList.toggle('hidden', number.toString() !== $step.dataset.step);
        });
    }

    /**
     * Redirige l'utilisateur vers la commande
     * 
     * @return {void}
     */
    redirectToOrder(): void {
        const url = new URL(location.href);
        url.searchParams.delete('pvid');

        location.href = url.toString();
    }
}
